import React, { useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { observer } from 'mobx-react';
import TextInput from '../../../components/forms/TextInput';
import settingsStorage from '../../../storages/mobx/settingsStorage';
import StandardButton from '../../../components/buttons/Base/StandardButton';
import authStorage from '../../../storages/mobx/authStorage';
import ChangeableImage from '../../../components/images/ChangeableImage';

const TextsSettings = ({ t }) => {
  useEffect(() => {
    settingsStorage.loadTexts();
  }, []);
  const {
    converstionStart,
    requestPhone,
    afterPhoneReceived,
    textForSharePhone,
    textForEsputnikViber,
    textForEsputnikViberButton,
    textForEsputnikViberImage,
    textForNewClients,
  } = settingsStorage.texts;

  const {
    changeTextField,
    isTextsChanged,
    textsChanged,
    saveTexts,
    getEsputnikImageUploadParams,
    handleEsputnikImageUpload,
  } = settingsStorage;
  return (
    <div>
      <TextInput
        id="converstionStart"
        value={converstionStart?.content}
        placeholder={t('Greeting')}
        onInput={changeTextField}
        className={textsChanged?.converstionStart ? 'is-invalid' : null}
      />
      <TextInput
        id="requestPhone"
        value={requestPhone?.content}
        placeholder={t('Request phone')}
        onInput={changeTextField}
        className={textsChanged?.requestPhone ? 'is-invalid' : null}
      />
      <TextInput
        id="afterPhoneReceived"
        value={afterPhoneReceived?.content}
        placeholder={t('Thanks for share phone')}
        onInput={changeTextField}
        className={textsChanged?.afterPhoneReceived ? 'is-invalid' : null}
      />
      <TextInput
        id="textForSharePhone"
        value={textForSharePhone?.content}
        placeholder={t('Text for share phone')}
        onInput={changeTextField}
        className={textsChanged?.textForSharePhone ? 'is-invalid' : null}
      />
      <TextInput
        id="textForNewClients"
        value={textForNewClients?.content}
        placeholder={t('Text for new clients')}
        onInput={changeTextField}
        className={textsChanged?.textForSharePhone ? 'is-invalid' : null}
      />
      <fieldset>
        <legend>{t('Esputnik invite settings')}</legend>
        <TextInput
          type="textarea"
          id="textForEsputnikViber"
          value={textForEsputnikViber?.content}
          placeholder={t('Text for esputnik viber invite')}
          onInput={changeTextField}
          rows={7}
          className={`form-control ${textsChanged?.textForEsputnikViber ? 'is-invalid' : null}`}
        />
        <ChangeableImage
          // opened={authStorage.profileImageUploadDialogOpened}
          // toggle={authStorage.profileImageUploadDialogToggle}
          // onSave={authStorage.saveProfile}
          getUploadParams={getEsputnikImageUploadParams}
          handleUpload={handleEsputnikImageUpload}
          cancelText={t('Close')}
          saveText={t('Save')}
          image={textForEsputnikViberImage?.content || null}
          imageClassName={`border-radius-0 w-100 ${textsChanged?.textForEsputnikViberButton ? 'is-invalid' : ''}`}
        />
        <TextInput
          id="textForEsputnikViberButton"
          value={textForEsputnikViberButton?.content}
          placeholder={t('Text for invite button')}
          onInput={changeTextField}
          rows={7}
          className={`form-control ${textsChanged?.textForEsputnikViberButton ? 'is-invalid' : null}`}
        />
      </fieldset>
      <div>
        <StandardButton
          onClick={saveTexts}
          disabled={!isTextsChanged}
        >
          {t('Save')}
        </StandardButton>
      </div>
    </div>
  );
};

export default translate(observer(TextsSettings));
